import React, { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  getQuotaForApproval,
  rejectModificationSingle,
  setState,
  Upload,
} from "./quotaModificationApprovalSlice";
import { Button, TextField, Typography, Grid } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  borderRadius: 1,
};

export default function RejectSelectedModal() {
  const dispatch = useDispatch();
  const [uploadedEditFile, setuploadedEditFile] = useState([]);
  const {
    rejectScenarioModalSingleOpen,
    rejectSelectedComment,
    selectedCountryID,
    selectedPeriod,
    selectedQuotaStatus,
    quotaList,
    selectedModificationid,
    searchText,
    scenarioModificationList,
    files,
  } = useSelector((store) => store.quotaModification);

  function handleClose() {
    dispatch(setState("rejectScenarioModalSingleOpen", false));
    dispatch(setState("rejectSelectedComment", ""));
    dispatch(setState("files", []));
    dispatch(setState("selectedModificationid", null));
    setuploadedEditFile([]);
    dispatch(setState("filepaths", []));
  }

  function setComment(event) {
    const comment = event.target.value;
    dispatch(setState("rejectSelectedComment", comment));
  }

  function search() {
    dispatch(setState("rejectSelectedComment", ""));
    dispatch(setState("selectedRowsselected", []));
    dispatch(setState("scenarioModificationList", null));
    dispatch(setState("expandedRowIndex", null));
    dispatch(setState("files", []));
    setuploadedEditFile([]);
    dispatch(setState("filepaths", []));
    dispatch(setState("selectedModificationid", null));
    const logedUser = JSON.parse(localStorage.getItem("data"));
    const countryId = selectedCountryID;
    const period = selectedPeriod;
    const quotaStatus = selectedQuotaStatus;

    const obj = {
      countryId,
      period,
      quotaStatus,
      logedUser,
      searchText: searchText,
    };
    dispatch(getQuotaForApproval(obj));
  }

  function rejectSelected() {
    let formData = preparePayload();
    console.log("Approve_Modification_RejectSelected", formData);
    dispatch(rejectModificationSingle(formData)).then(() => {
      search();
    });
    handleClose();
  }
  function preparePayload() {
    let quota = scenarioModificationList.find(
      (item) => item.modificationId === selectedModificationid
    );
    const user = JSON.parse(localStorage.getItem("data"));
    const country = user.userCountries.find(
      (index) => index.country.countryID === quota.geoId
    ).country;

    const formData = new FormData();

    formData.append("quotaId", quota.quotaId);
    formData.append("modificationId", quota.modificationId);
    formData.append("scenarioId", quota.scenarioId);
    formData.append("scenarioName", quota.scenarioName);
    formData.append("geoId", quota.geoId);
    formData.append("comments", quota.comments);
    formData.append("modificationStatus", quota.modificationStatus);
    formData.append("differenceInQuota", quota.differenceInQuota);
    formData.append("lastActionBy", quota.lastActionBy);
    formData.append("creationDate", quota.creationDate);
    formData.append("createdBy", quota.createdBy);
    formData.append("lastActionDate", quota.lastActionDate);
    formData.append("createdDate", quota.createdDate);
    formData.append("approvedRejectedBy", quota.approvedRejectedBy);
    formData.append("rejectionComments", rejectSelectedComment);
    formData.append("sentToSAPFlag", quota.sentToSAPFlag);
    formData.append("approveComments", quota.approveComments);
    formData.append("depletionModel", quota.depletionModel);
    formData.append("user[userID]", user.userID);
    formData.append("user[firstName]", user.firstName);
    formData.append("user[lastName]", user.lastName);
    formData.append("user[email]", user.email);
    formData.append("user[roleID]", user.roleID);
    formData.append("user[roleName]", user.roleName);
    formData.append("user[isAdmin]", user.isAdmin);
    formData.append("user[activeFlag]", user.activeFlag);
    formData.append("user[isFirstTimeUser]", user.isFirstTimeUser);
    formData.append("user[passwordChangeDate]", user.passwordChangeDate);
    formData.append("user[isIMSUser]", user.isIMSUser);
    for (var i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }
    user.userCountries.forEach((country, index) => {
      formData.append(`user[userCountries][${index}][userID]`, country.userID);
      formData.append(
        `user[userCountries][${index}][country][countryID]`,
        country.country.countryID
      );
      formData.append(
        `user[userCountries][${index}][country][countryName]`,
        country.country.countryName
      );
      formData.append(
        `user[userCountries][${index}][country][countryCode]`,
        country.country.countryCode
      );
      formData.append(
        `user[userCountries][${index}][country][countrySalesOrganizationCode]`,
        country.country.countrySalesOrganizationCode
      );
    });

    user.userCustomerTypes.forEach((type, index) => {
      formData.append(`user[userCustomerTypes][${index}][userID]`, type.userID);
      formData.append(
        `user[userCustomerTypes][${index}][customerTypeBO][customerTypeCode]`,
        type.customerTypeBO.customerTypeCode
      );
      formData.append(
        `user[userCustomerTypes][${index}][customerTypeBO][customerTypeName]`,
        type.customerTypeBO.customerTypeName
      );
    });
    formData.append("user[token]", user.token);
    formData.append("canApproveReject", true);

    return formData;
  }
  const handleFileUpload = (event) => {
    const fileObj = event.target.files[0];
    let file = [...uploadedEditFile];
    file.push(fileObj);
    setuploadedEditFile(file);
    dispatch(setState("files", file));
  };

  const handleDelete = (name) => {
    const file = uploadedEditFile.filter((file) => file.name !== name);
    setuploadedEditFile(file);
    dispatch(setState("files", file));
  };

  return (
    <Box>
      <Modal open={rejectScenarioModalSingleOpen} onClose={handleClose}>
        <Box sx={style}>
          <Typography variant="subtitle2">Comments</Typography>
          <TextField
            className={"fullWidth"}
            size="large"
            multiline
            rows={6}
            style={{ overflowY: "auto" }}
            value={rejectSelectedComment}
            onChange={setComment}
          />
          <br />
          <Grid item>
            <Box>
              <input
                type="file"
                onChange={handleFileUpload}
                style={{ display: "none" }}
                id="fileInput"
                onclick="fileInput.value = null"
                value=""
              />
              <label htmlFor="fileInput">
                <Button
                  variant="contained"
                  sx={{
                    bgcolor: "skyBlue.main",
                    color: "blue.main",
                    textTransform: "none",
                    mt: 1,
                    "&:hover": {
                      bgcolor: "blue.main",
                      color: "white.main",
                    },
                  }}
                  component="span"
                >
                  Upload File
                </Button>
              </label>
            </Box>
          </Grid>
          <Grid>
            {uploadedEditFile.map((file) => (
               <Box sx={{ mt: 2, borderBottom: 0.25, borderColor: "#e0e0e0" }}>
                       <div className="file-display" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span>{file.name}</span>
                  {/* <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => handleDelete(file.name)}
                  > */}
                    <DeleteIcon onClick={() => handleDelete(file.name)} sx={{ cursor: "pointer" }} />
                  {/* </Button> */}
                </div>
              </Box>
            ))}
          </Grid>
          <br />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            <Button
              sx={{
                bgcolor: "blue.main",
                color: "white.main",
                textTransform: "none",
                fontWeight: "bold",
                mt: 1,
                mr: 2,
                "&:hover": {
                  bgcolor: "skyBlue.main",
                  color: "black.main",
                },
              }}
              onClick={handleClose}
            >
              Close
            </Button>

            <Button
              sx={{
                bgcolor: "blue.main",
                color: "white.main",
                textTransform: "none",
                fontWeight: "bold",
                mt: 1,
                "&:hover": {
                  bgcolor: "skyBlue.main",
                  color: "black.main",
                },
              }}
              onClick={rejectSelected}
            >
              Reject
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
